export default {
  tableHeader: {
    observationCount: 'Menge',
  },
  empty: 'Keine Beobachtungen gefunden',
};
